export enum ArtTreatmentIntegrity {
	Adjacent = 10,
	RestorationPlanned = 11,
	Missing = 12,
	MissingRestorationPlanned = 13,
	PreviouslyRestored = 14
}

export enum ArtTreatmentDefinition {
	AttachmentRestricted = 20,
	ExtractionPlanned = 21,
	Unmovable = 22
}

export type ArtTreatmentIndication = ArtTreatmentIntegrity | ArtTreatmentDefinition;
